import Box from '@mui/material/Box';
import Button from 'common/components/Elements/Button/Button';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import classes from 'core/components/Elements/Command/Command.style';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import type { EnhancedCommand } from 'core/utilities/core.types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export interface ComponentProps {
  command: EnhancedCommand;
}

function CommandSave({ command }: ComponentProps) {
  const {
    id, title, active, shortcut, action, label,
  } = command;
  const ref = React.createRef<HTMLButtonElement>();
  const persistingCommand = useSelector((state: ApplicationState) => state.page.persistingCommand);
  const persisting = persistingCommand && persistingCommand.id === id;

  const shortcutTrigger = useShortcut(...(shortcut || []));
  const prevShortcutTrigger = useRef(shortcutTrigger);

  useEffect(() => {
    if (shortcutTrigger && prevShortcutTrigger.current !== shortcutTrigger && !persisting && ref.current) {
      ref.current.click();
    }

    prevShortcutTrigger.current = shortcutTrigger;
  }, [persisting, ref, shortcutTrigger]);

  return (
    <Box position="relative" display="inline-block">
      <Button
        submit
        action={action || 'primary'}
        className={classes.command}
        title={title}
        disabled={active === false || persisting}
        data-e2e-button={id}
        buttonRef={ref}
        buttonIcon={label === undefined}
      >
        <CommandLinkContent command={command} />
      </Button>
      {persisting && (
        <ButtonLoading />
      )}
    </Box>
  );
}

export default CommandSave;
